import React from 'react';
import { Route } from 'react-router-dom';

import iconHeartrate from '../../assets/svg/icon-heartrate.svg';
import iconCheck from '../../assets/svg/icon-check.svg';
import iconSpeak from '../../assets/svg/icon-speak.svg';
import iconPenny from '../../assets/svg/icon-penny.svg';
import iconOnline from '../../assets/svg/icon-online.svg';
import iconGym from '../../assets/svg/icon-gym.svg';
import iconSavings from '../../assets/svg/icon-savings.svg';
import VimeoEmbed from '../../components/VimeoEmbed/VimeoEmbed';

const reasons = (props) => {
  return (
    <section className='divide p60'>
      <div className='wrap'>
        <h2>A few reasons why you&rsquo;ll&nbsp;love&nbsp;us.</h2>
        <ul className='three-col reasons'>
          <li className='col'>
            <span><img src={iconHeartrate} alt='Physicals and preventive screenings' /></span>
            <p>Physicals and preventive<br /> screenings at no cost to you</p>
          </li>
          <li className='col'>
            <span><img src={iconCheck} alt='Pre-existing conditions' className='pre-existing' /></span>
            <p>Coverage for all your<br /> pre-existing conditions</p>
          </li>
          <li className='col'>
            <span><img src={iconSpeak} alt='Call local reps' /></span>
            <p>Live, local reps to answer<br /> your call in just seconds</p>
          </li>
          <li className='col'>
            <span><img src={iconPenny} alt='Penny Prescription' className='penny' /></span>
            <p>Prescription coverage starting<br /> as low as a dollar a fill</p>
          </li>
          <li className='col'>
            <span><img src={iconOnline} alt='Ability to see a doctor online' /></span>
            <p>Ability to see a doctor online<br /> from the comfort of home</p>
          </li>

          <Route
            path='/'
            exact
            render={() =>
              <li className='col'>
                <span><img src={iconGym} alt='Free fitness classes' className='gyms' /></span>
                <p>Free fitness classes to help<br /> you stay healthy</p>
              </li>
            } />

          <Route
            path='/individuals-families'
            exact
            render={() =>
              <li className='col'>
                <span><img src={iconGym} alt='Free fitness classes' className='gyms' /></span>
                <p>Free fitness classes to help you stay healthy</p>
              </li>
            } />

          <Route
            path='/small-business'
            exact
            render={() =>
              <li className='col'>
                <span><img src={iconSavings} alt='Funding Account Options' className='gyms' /></span>
                <p>Funding account options to<br /> help your staff save money</p>
              </li>
            } />

        </ul>

        <Route
          path='/small-business'
          exact
          render={() =>
            <div className='wrap sm'>
              <div id='innovation'>&nbsp;</div>
              <VimeoEmbed videoId='1219852264' hash='f7a6b557f6'
                title='Innovative Group Health Plans from CDPHP' />
            </div>
          } />

      </div>
    </section>
  );
};

export default reasons;
